import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const mailchimpConfigEntity: Entity = {
  model: model,
  repository: repository,
}

export default mailchimpConfigEntity
